<template>
    <div>
        <loading :active.sync="loading.content" :can-cancel="false" :is-full-page="true" :color="'#0B8BCC'" :loader="'dots'" :opacity="0.7" :lock-scroll="true"></loading>
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <a @click="$router.go(-1)" class="headerButton">
                <!-- <router-link :to="{name:'home'}" class="headerButton"> -->
                    <ion-icon name="chevron-back-outline"></ion-icon>
                <!-- </router-link> -->
                </a>
            </div>
            <div class="pageTitle">Semua</div>
        </div>
        <div id="appCapsule" v-if="loading.content == false">
            <div class="section inset mt-2">
                <div class="order-menu p-0 m-0">
                    <h3 style="font-weight:bold;" class="mb-0">Isi Ulang</h3>
                    <span style="font-size:13px;">Dengan Qiosfin isi ulang apapun jadi mudah</span>
                    <hr style="margin-top:5px;">
                    <div class="menu" v-for="chunks in chunkCategoryPrabayar" :key="chunks.index">
                        <div class="item" v-for="item in chunks" :key="item.id" style="flex:none;">
                            <!-- <router-link :to="{name:'prabayar', params:{id:item.id, title:item.product_name, withPrefix:item.withPrefix}}">
                                <img :src="VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon" alt="image" class="imaged" style="width:70%;">
                                <strong>{{ item.product_name }}</strong>
                            </router-link> -->
                            <router-link :to="{name:'product-prabayar-prefix', params:{id:item.id, title:item.product_name, withPrefix:item.withPrefix}}" v-if="item.withPrefix === 1">
                                <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="imaged" style="width:60%;">
                                <strong :class="item.product_name == 'Loading...' ? 'loading-component':''" style="margin:3px;font-size:10px;"><span>{{ item.product_name }}</span></strong>
                            </router-link>

                            <router-link :to="{name:'product-prabayar', params:{id:item.id, title:item.product_name, withPrefix:item.withPrefix, styleProduct:item.style_product}}" v-else>
                                <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="imaged" style="width:60%;">
                                <strong :class="item.product_name == 'Loading...' ? 'loading-component':''" style="margin:3px;font-size:10px;"><span>{{ item.product_name }}</span></strong>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
            <div class="section inset mt-2" v-if="chunkCategoryPascabayar.length > 0">
                <div class="order-menu p-0 m-0">
                    <h3 style="font-weight:bold;" class="mb-0">Bayar Tagihan</h3>
                    <span style="font-size:13px;">Solusi semua pembayaran tagihan hanya di Qiosfin</span>
                    <hr style="margin-top:5px;">
                    <div class="menu" v-for="chunks in chunkCategoryPascabayar" :key="chunks.index">
                        <div class="item" v-for="item in chunks" :key="item.id" style="flex:none;">
                            <router-link :to="{name:'pascabayar', params:{id:item.id, title:item.product_name}}">
                                <img v-lazyload :src="require('@/assets/Loader-2.png')" :data-src="item.icon ? VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon:require('@/assets/Loader-2.png')" alt="image" class="imaged" style="width:60%;">
                                <strong :class="item.product_name == 'Loading...' ? 'loading-component':''" style="margin:3px;font-size:10px;"><span>{{ item.product_name }}</span></strong>
                            </router-link>
                            <!-- <router-link :to="{name:'pascabayar', params:{id:item.id, title:item.product_name}}">
                                <img :src="VUE_ENV.VUE_APP_ASSET_URL+'/img/icon/'+item.icon" alt="image" class="imaged" style="width:70%;">
                                <strong>{{ item.product_name }}</strong>
                            </router-link> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
export default {
    data: () => ({
        loading:{
            content: true
        }
    }),
    computed:{
        ...mapState(['categoryPrabayar','categoryPascabayar','VUE_ENV']),
        chunkCategoryPrabayar(){
            return window._.chunk(window._.toArray(this.categoryPrabayar),4)
        },
        chunkCategoryPascabayar(){
            return window._.chunk(window._.toArray(this.categoryPascabayar),4)
        }
    },
    methods: {
        ...mapActions(['getCategoryPrabayar','getCategoryPascabayar']),
    },
    mounted() {
        this.getCategoryPrabayar()
        this.getCategoryPascabayar().then(() => {
            this.loading.content = false
        }).catch(() => {
            this.loading.content = false
        })
    },
}
</script>